import React from 'react';
import HelpTooltip from '../HelpTooltip';
import TooltipDetails from '../TooltipDetails';

export default function SlotLabel(props) {
  const { fixed, option } = props;
  const { details, isDisabled, label } = option;
  const opacity = isDisabled ? '0.5' : '1';
  const labelElement = <span style={{ opacity }}>{label}</span>;
  if (!details || !details.source_urls) return labelElement;

  return (
    <div style={{ position: 'relative' }}>
      {labelElement}
      <HelpTooltip inline fixed={fixed}>
        <TooltipDetails details={details} />
      </HelpTooltip>
    </div>
  );
}
